import { Stack, Text } from '@guestyci/arc';
import t from '@guestyci/localize/t.macro';

const InstanceBanner = ({ testId = 'instance-banner' }) => {
  return (
    <Stack
      spacing={0}
      justify="center"
      align="center"
      data-testid={testId}
      className="gst-relative gst-bg-primary gst-w-full gst-h-14"
    >
      <Text variant="h4" className="gst-text-white">
        {t('Loading...')}
      </Text>
    </Stack>
  );
};

export default InstanceBanner;
